export const COMPLETE_MY_INFO_PENDING = 'COMPLETE_YOUR_INFO_PENDING';
export const COMPLETE_MY_INFO_SUCCESS = 'COMPLETE_YOUR_INFO_SUCCESS';
export const COMPLETE_MY_INFO_ERROR = 'COMPLETE_YOUR_INFO_ERROR';
